import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue"

import AppLogo from './AppLogo.vue'
import Auth from 'src/api/auth'
import DrawerToggleButton from 'src/components/layout/DrawerToggleButton.vue'
import { computed } from 'vue'
import { useDrawerStore } from 'src/stores/modules/drawer'


import { defineComponent } from 'vue'
const __default__ = defineComponent({ name: 'AppHeader' })

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useDrawerStore()
const open = computed(() => store.open)
const mini = computed(() => store.mini)

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!

  return (_openBlock(), _createBlock(_component_q_header, {
    class: "text-dark bg-white",
    reveal: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, null, {
        default: _withCtx(() => [
          (!open.value || mini.value)
            ? (_openBlock(), _createBlock(DrawerToggleButton, { key: 0 }))
            : _createCommentVNode("", true),
          (!open.value)
            ? (_openBlock(), _createBlock(AppLogo, {
                key: 1,
                class: "q-ml-sm"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_btn, {
            dense: "",
            "text-color": "grey-15",
            flat: "",
            round: "",
            icon: "mdi-logout",
            class: "q-ml-auto",
            onClick: _unref(Auth).logout
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_tooltip, null, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("Disconnetti", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})